// Event names
export const EVENTS = {
  BUTTON_CLICK: 'button_click',
  APP_CLICK: 'app_click',
  DESKTOP_VIEWED: 'desktop_viewed',
  APPS_VIEWED: 'apps_viewed',
  WINDOW_RESIZE: 'window_resize'
};

// Event properties
export const BUTTONS = {
  START: 'start_meeting',
  PORTFOLIO: 'view_portfolio',
  LINKEDIN: 'linkedin',
  X: 'x'
};
